import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {ApiMode, ConfigService} from '@shared-library';
import {environment} from '../../../environments/environment';
import {AuthService} from '../../services/auth.service';

@Component({
  selector: 'app-test-mode-redirect',
  templateUrl: './test-mode-redirect.component.html',
  standalone: false
})
export class TestModeRedirectComponent implements OnInit {
  constructor(
    private configService: ConfigService,
    private authService: AuthService,
    private router: Router,
  ) {}

  async ngOnInit(): Promise<void> {
    const publicId = environment.org_credential_test_public_id;
    const currentSystemConfig = {...this.configService.systemConfig$};
    const nextSystemConfig = {
      ...currentSystemConfig,
      publicId,
      apiMode: this.getApiModeFromPublicId(publicId),
      org: undefined,
    };

    this.configService.systemConfigSubject.next(nextSystemConfig);

    await this.authService.Signout();
    await this.router.navigateByUrl('/auth/signin', {replaceUrl: true});
  }

  private getApiModeFromPublicId(publicId: string): ApiMode {
    const publicIdParts = publicId.split('_');
    if (publicIdParts.length === 3 && publicIdParts[1] === ApiMode.Live) {
      return ApiMode.Live;
    }

    return ApiMode.Test;
  }
}
